import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
// Components
import AuthRoute from 'routes/components/AuthRoute';
import PageHeader from 'components/PageHeader';
// Pages
import Home from 'pages/Home';
import Dispatcher from 'pages/Dispatcher';
import EventLog from 'pages/EventLog';
import PackSite from 'pages/PackSite';
import SalesOrder from 'pages/SalesOrder';
import UserAdmin from './userAdmin';

function Routes() {
  return (
    <Switch>
      <AuthRoute exact path="/" component={Home} />
      <Route exact path="/login">
        <Redirect to="/" />
      </Route>
      <AuthRoute
        path="/user-admin"
        component={UserAdmin}
        permissions={['PLANNING ADMIN']}
      />
      <AuthRoute
        component={Dispatcher}
        path="/dispatcher"
        permissions={['PLANNING ADMIN', 'PLANNING', 'WAREHOUSE']}
      />
      <AuthRoute
        component={EventLog}
        path="/event-log"
        permissions={['PLANNING ADMIN', 'PLANNING', 'WAREHOUSE', 'MASTER DATA']}
      />
      <AuthRoute
        component={PackSite}
        path="/pack-site"
        permissions={['PLANNING']}
      />
      <AuthRoute
        component={SalesOrder}
        path="/sales-order"
        permissions={['PLANNING']}
      />
      <AuthRoute
        component={
          <PageHeader
            heading="404 Error"
            subHeading="The page you are looking for could not be found."
          />
        }
        path="*"
      />
    </Switch>
  );
}

export default Routes;